// extracted by mini-css-extract-plugin
export default {"LayoutContent":"LoadedApp_LayoutContent__4pb2C"};